import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;

const header={
   'Content-Type': 'application/json; charset=UTF-8',
   "Accept": "application/json",
   "Access-Control-Allow-Origin": "*", // Required for CORS support to work
   "Authorization": getCookie("mawalog")
 }

 export const getVehicleScanDataApi = async (qrTag) => { 
  try {
    const response = await axios.get(
      apiUrl+`get_vehicle_details/`+qrTag,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};

 export const getDockListApi = async (params) => { 
  try {
    const response = await axios.get(
      apiUrl+`dock?`+params,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getDockViewApi = async (params) => { 
  try {
    const response = await axios.get(
      apiUrl+`dock/get/`+params,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
 
export const createDockApi = async (data) => {  
  try {
    const response = await axios.post(
      apiUrl+`dock`,data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...',error.response)
        return error.response;
        /* if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
       
        } else {
          console.error("Request failed:", error.message);
        } */
      });
      return response; 
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
 
export const uploadDockAttachmentApi = async (data) => {  
  try {
    const response = await axios.post(
      apiUrl+`dock_updateattachment`,data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...',error.response)
        return error.response;
      });
      return response; 
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const dockOutApi = async (id,data) => {  
  try {
    const response = await axios.post(
      apiUrl+`dock/${id}/dockout`,data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...',error.response)
        return error.response;       
      });
      return response; 
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
//  export const getCountApi = async () => { 
//   try {
//     const response = await axios.get(
//       apiUrl+`dashboard/count`,
//       {
//         headers: header,
//       }
//     );
// return response;
//   } catch (err) {
//     console.error("Error fetching category:", err);
//   } finally {
//   }
// };


//  export const getLocationFreeDocksApi = async () => { 
//   try {
//     const response = await axios.get(
//       apiUrl+`dashboard/freedocks?search=`,
//       {
//         headers: header,
//       }
//     );
// return response;
//   } catch (err) {
//     console.error("Error fetching category:", err);
//   } finally {
//   }
// };

// export const getLiveMonitorApi = async () => { 
//   try {
//     const response = await axios.get(
//       apiUrl+`dashboard/livemonitor`,
//       {
//         headers: header,
//       }
//     );
// return response;
//   } catch (err) {
//     console.error("Error fetching category:", err);
//   } finally {
//   }
// };

// export const getTimingListApi = async () => { 
//   try {
//     const response = await axios.get(
//       apiUrl+`dashboard/timings`,
//       {
//         headers: header,
//       }
//     );
// return response;
//   } catch (err) {
//     console.error("Error fetching category:", err);
//   } finally {
//   }
// };
// export const locationBasedDockOutDockInApi = async (month) => {  
//   try {
//     const response = await axios.post(
//       apiUrl+`dashboard/location_in_out?period=01-2025&search=`,{}, { headers: header });
// return response;
//   } catch (err) {
//     console.error("Error fetching category:", err);
//   } finally {
//   }
// };

// export const sendOTPApi = async (data) => {  
//    try {
//      const response = await axios.post(
//        apiUrl+`sent_otp`,data, { headers: header });
//  return response.data;
//    } catch (err) {
//      console.error("Error fetching category:", err);
//    } finally {
//    }
//  };
 
//  export const verifyOTPApi = async (data) => {  
//    try {
//      const response = await axios.post(
//        apiUrl+`verify_otp`,data, { headers: header });
//  return response.data;
//    } catch (err) {
//      console.error("Error fetching category:", err);
//    } finally {
//    }
//  };